export enum TRAITS {
  MAP_TO_TRAIT,
  CUSTOM_TRAIT,
  CONSENT_TRAIT,
  IGNORE_COLUMN,
}

export const CONSENT_TRAIT = 'consent_trait';

export const CUSTOMER = 'CUSTOMER';
export const EVENT = 'EVENT';